/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CategoryResponseDashboardDto } from '../../models/category-response-dashboard-dto';

export interface DashboardCategoriesControllerListCategoriesV1$Params {

/**
 * Optional search string for filtering categories
 */
  search?: string;
}

export function dashboardCategoriesControllerListCategoriesV1(http: HttpClient, rootUrl: string, params?: DashboardCategoriesControllerListCategoriesV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CategoryResponseDashboardDto>>> {
  const rb = new RequestBuilder(rootUrl, dashboardCategoriesControllerListCategoriesV1.PATH, 'get');
  if (params) {
    rb.query('search', params.search, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CategoryResponseDashboardDto>>;
    })
  );
}

dashboardCategoriesControllerListCategoriesV1.PATH = '/v1/dashboard/categories';
